<template>
    <header class="main">
        <div class="row-fixed">
            <info-wrap></info-wrap>
            <div class="logo-wrap">
                <div class="logo-container">
                    <img class="logo" src="../assets/img/logo.svg" alt="Logo">
                    <span class="title">TopUp Africa</span>
                    <span class="tagline">Limited</span>
                    <a href="https://web.tua.ng/?refresh" target="_blank" class="button button-primary">create account</a>
                    <a href="https://web.tua.ng/?refresh" target="_blank" class="login">
                        <span>or Log In</span>
                    </a>
                </div>
                <ui-polygon :left="'2%'" :box="'0 60 27 130'"></ui-polygon>
                <ui-polygon :left="'12%'" :box="'0 140 27 140'"></ui-polygon>
                <ui-polygon :left="'32%'" :box="'0 90 27 140'"></ui-polygon>
                <ui-polygon :left="'52%'" :box="'0 160 27 140'"></ui-polygon>
                <ui-polygon :left="'72%'" :box="'0 15 27 140'"></ui-polygon>
                <ui-polygon :left="'82%'" :box="'0 130 27 140'"></ui-polygon>
                <ui-polygon :left="'92%'" :box="'0 190 27 140'"></ui-polygon>
                <ui-button :icon="'payOnline'" :tagline="'Make a payment now without registration'"></ui-button>
            </div>
            <div class="banner-wrap">
                <img src="../assets/img/tua-product.png" alt="Tua Product">
                <ui-button :icon="'appStore'"></ui-button>
            </div>
        </div>
        <div class="row-line"></div>
    </header>
</template>

<style>
.ui-polygon {
  display: none;
  position: absolute;
  top: 0;
}
@media screen and (max-width: 630px) {
  .row-icons .items .items-row {
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: center;
  }
  .row-icons .items .items-row .item {
    width: 34%;
  }
  .row-icons .items .items-row .item a {
    margin: 0 auto;
  }
}
@media screen and (max-width: 620px) {
  header.main .row-fixed .logo-wrap {
    -webkit-box-shadow: none;
    box-shadow: none;
    width: 100%;
    height: 526px;
  }
  .download-button {
    height: 72px !important;
  }
  header.main .row-fixed .logo-wrap {
    overflow: hidden;
  }
  .download-button .download-button-tagline,
  header.main .row-fixed .logo-wrap .logo-container {
    display: none;
  }
  header.main .row-fixed,
  header.main .row-fixed .logo-wrap {
    height: 526px;
  }
  .ui-polygon {
    display: block;
  }
}
@media screen and (max-width: 480px) {
  .row-icons .items .items-row .item {
    width: 50%;
  }
}
@media screen and (max-width: 414px) {
  .row-icons {
    margin: 20px 0 30px!important;
  }
  .row-icons h2 {
    width: 80%;
    margin: 12px auto!important;
    border-top: 2px solid #979797;
    padding-top: 25px!important;
  }
}
</style>

<script>
import infoWrap from './infoWrap';
import button from './elements/downloadButton';
import polygon from '../assets/icons/polygon';

export default {
  components: {
    infoWrap,
    'ui-button': button,
    'ui-polygon': polygon
  }
};
</script>



// WEBPACK FOOTER //
// src/components/header.vue